'use strict';

var React = require('react');
var index = require('./index-0e40e0c2.js');
var _extends = require('./extends-f8003900.js');
var defineProperty = require('./defineProperty-3cad0327.js');
var objectWithoutProperties = require('./objectWithoutProperties-aa43106a.js');
var xstyledStyledComponents_es = require('./xstyled-styled-components.es-02f83f64.js');
var styles_themeUtils = require('./styles/themeUtils.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;
var SVGWrapper = xstyledStyledComponents_es.styled.svg(_templateObject || (_templateObject = xstyledStyledComponents_es.taggedTemplateLiteral(["\n  path {\n    fill: ", ";\n  }\n"])), function (_ref) {
  var color = _ref.color,
      colorVariant = _ref.colorVariant,
      theme = objectWithoutProperties.objectWithoutProperties(_ref, ["color", "colorVariant"]);

  return color === 'currentColor' ? color : styles_themeUtils.nuDSColor(color, colorVariant)(theme);
});

var _sizes;
var SMALL = 'small';
var DEFAULT = 'default';
var sizes = (_sizes = {}, defineProperty.defineProperty(_sizes, DEFAULT, {
  width: 20,
  height: 20
}), defineProperty.defineProperty(_sizes, SMALL, {
  width: 16,
  height: 16
}), _sizes);

var IconStructure = function IconStructure(_ref) {
  var children = _ref.children,
      className = _ref.className,
      size = _ref.size,
      viewBox = _ref.viewBox,
      color = _ref.color,
      colorVariant = _ref.colorVariant,
      title = _ref.title,
      ariaHidden = _ref.ariaHidden;
  var iconSize = sizes[size.toLowerCase()];
  return /*#__PURE__*/React__default['default'].createElement(SVGWrapper, {
    xmlns: "http://www.w3.org/2000/svg",
    width: iconSize.width,
    height: iconSize.height,
    fill: "none",
    viewBox: viewBox,
    className: className,
    color: color,
    colorVariant: colorVariant,
    "aria-hidden": ariaHidden,
    role: "img"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, title), children);
};

var iconPropTypes = {
  size: index.PropTypes.oneOf([SMALL, DEFAULT]),
  color: index.PropTypes.string,
  colorVariant: index.PropTypes.string,
  title: index.PropTypes.string,
  className: index.PropTypes.string,
  children: index.PropTypes.node,
  ariaHidden: index.PropTypes.string
};
IconStructure.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  ariaHidden: undefined,
  color: 'currentColor',
  colorVariant: 'default',
  size: DEFAULT,
  viewBox: '0 0 20 20'
  /* eslint-enable react/default-props-match-prop-types */

};
IconStructure.propTypes = _extends._extends({}, iconPropTypes, {
  children: index.PropTypes.node.isRequired
});

var twitter = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.5 6.4C0.5 4.15979 0.5 3.03969 0.935974 2.18404C1.31947 1.43139 1.93139 0.819467 2.68404 0.435974C3.53969 0 4.65979 0 6.9 0H14.1C16.3402 0 17.4603 0 18.316 0.435974C19.0686 0.819467 19.6805 1.43139 20.064 2.18404C20.5 3.03969 20.5 4.15979 20.5 6.4V13.6C20.5 15.8402 20.5 16.9603 20.064 17.816C19.6805 18.5686 19.0686 19.1805 18.316 19.564C17.4603 20 16.3402 20 14.1 20H6.9C4.65979 20 3.53969 20 2.68404 19.564C1.93139 19.1805 1.31947 18.5686 0.935974 17.816C0.5 16.9603 0.5 15.8402 0.5 13.6V6.4ZM15.6735 7.60187C15.6735 11.2667 12.9892 15.5 8.08363 15.5C6.58023 15.5 5.17567 15.0399 4 14.2603C4.20808 14.2874 4.42137 14.2982 4.63465 14.2982C5.88315 14.2982 7.03281 13.8543 7.94838 13.1073C6.78311 13.0856 5.79472 12.2844 5.45658 11.1801C5.61785 11.2126 5.78431 11.2288 5.95598 11.2288C6.20048 11.2288 6.43457 11.1964 6.65826 11.1314C5.44098 10.877 4.52021 9.75098 4.52021 8.40846V8.37057C4.87915 8.57628 5.29012 8.70079 5.72709 8.71703C5.01441 8.219 4.54102 7.36909 4.54102 6.40551C4.54102 5.89665 4.67107 5.42028 4.89996 5.00886C6.21609 6.68701 8.18247 7.79675 10.3986 7.91043C10.3569 7.70472 10.3309 7.4936 10.3309 7.27707C10.3309 5.74508 11.5274 4.5 12.9996 4.5C13.7643 4.5 14.4562 4.83563 14.9452 5.37697C15.5538 5.25246 16.126 5.0251 16.6411 4.70571C16.4382 5.35531 16.0168 5.90207 15.4654 6.24311C16.0064 6.17274 16.5214 6.02657 17 5.80463C16.6411 6.3622 16.1885 6.85482 15.6683 7.24459C15.6735 7.36368 15.6735 7.48278 15.6735 7.60187Z\" fill=\"#111111\"/>\n  ",
  title: 'Twitter Icon',
  viewBox: '0 0 21 20'
};

var youtube = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.935974 2.18404C0.5 3.03969 0.5 4.15979 0.5 6.4V13.6C0.5 15.8402 0.5 16.9603 0.935974 17.816C1.31947 18.5686 1.93139 19.1805 2.68404 19.564C3.53969 20 4.65979 20 6.9 20H14.1C16.3402 20 17.4603 20 18.316 19.564C19.0686 19.1805 19.6805 18.5686 20.064 17.816C20.5 16.9603 20.5 15.8402 20.5 13.6V6.4C20.5 4.15979 20.5 3.03969 20.064 2.18404C19.6805 1.43139 19.0686 0.819467 18.316 0.435974C17.4603 0 16.3402 0 14.1 0H6.9C4.65979 0 3.53969 0 2.68404 0.435974C1.93139 0.819467 1.31947 1.43139 0.935974 2.18404ZM14.2443 9.59091L8.2485 6.06817C7.91378 5.87151 7.5 6.12386 7.5 6.52465V13.4754C7.5 13.8735 7.9088 14.1261 8.24342 13.9348L14.2392 10.5068C14.5846 10.3093 14.5875 9.79258 14.2443 9.59091Z\" fill=\"#111111\"/>\n  ",
  title: 'Youtube Icon',
  viewBox: '0 0 21 20'
};

var xCircle = {
  svgPath: "\n    <g clip-path=\"url(#clip0)\">\n      <path d=\"M10.5 8.586l3-3L14.914 7l-3 3 3 3-1.414 1.414-3-3-3 3L6.086 13l3-3-3-3L7.5 5.586l3 3z\"/>\n      <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 20c5.523 0 10-4.477 10-10s-4.477-10-10-10S.5 4.477.5 10s4.477 10 10 10zm0-2a8 8 0 100-16 8 8 0 000 16z\"/>\n    </g>\n    <defs>\n      <clipPath id=\"clip0\">\n      <path d=\"M.5 0h20v20H.5z\"/>\n    </clipPath>\n    </defs>\n  ",
  title: 'X Circle',
  viewBox: '0 0 21 20'
};

var checkCircle = {
  svgPath: "\n    <path d=\"M5.086 10l3.207 3.207a1 1 0 001.414 0L14.914 8 13.5 6.586l-4.5 4.5-2.5-2.5L5.086 10z\"/>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z\"/>\n  ",
  title: 'Check Circle'
};

var menu = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.5 7H20.5V5H0.5V7ZM0.5 15H20.5V13H0.5V15Z\"/>\n  ",
  title: 'Menu',
  viewBox: '0 0 21 20'
};

var search = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.61499 15.1539C9.81545 17.4036 14.2434 17.0842 17.0954 14.1958C20.3019 10.9483 20.3019 5.6831 17.0954 2.43562C13.8889 -0.811872 8.6902 -0.811872 5.48372 2.43562C2.40019 5.55858 2.28196 10.5475 5.12903 13.8136L0.5 18.6108L1.93922 19.9996L6.61499 15.1539ZM15.6902 12.7726C13.2598 15.2341 9.31933 15.2341 6.88892 12.7726C4.45851 10.3111 4.45851 6.32028 6.88892 3.85878C9.31933 1.39729 13.2598 1.39729 15.6902 3.85878C18.1206 6.32028 18.1206 10.3111 15.6902 12.7726Z\"/>\n  ",
  title: 'Search'
};

var x = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5001 11.4143L16.793 17.7072L18.2072 16.293L11.9143 10.0001L18.2072 3.70718L16.793 2.29297L10.5001 8.58587L4.20718 2.29297L2.79297 3.70718L9.08587 10.0001L2.79297 16.293L4.20718 17.7072L10.5001 11.4143Z\"/>\n  ",
  title: 'x',
  viewBox: '0 0 21 20'
};

var pencil = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.109 2.7a.4.4 0 00-.568.001L12.2 4.051l4.255 4.253 1.348-1.347a.401.401 0 000-.567L14.109 2.7zm.93 7.018l-4.252-4.25L2.5 13.75V18h4.253l8.286-8.282zm4.176-1.346a2.4 2.4 0 000-3.397l-3.692-3.69a2.4 2.4 0 00-3.4.006L10.08 3.346l-.003.002-9.284 9.28a1 1 0 00-.293.707V19a1 1 0 001 1h5.667a1 1 0 00.707-.293L19.215 8.372z\" />\n  ",
  title: 'Pencil',
  viewBox: '0 0 21 20'
};

var minus = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.00012 11C1.00004 11 1 11 1 10C1 9 1.00004 9 1.00012 9L19 9L19 11L1.00012 11Z\"/>\n  ",
  title: 'Minus',
  viewBox: '0 0 21 20'
};

var plus = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.9779 9L18 9V11H10.9779V18H8.9779L8.97791 11H2L2 9L8.97791 9L8.97791 2L10.9779 2V9Z\"/>\n  ",
  title: 'Plus',
  viewBox: '0 0 20 20'
};

var circle = {
  svgPath: "\n    <g clip-path=\"url(#clip0)\">\n        <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.5 18a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10s-4.477-10-10-10S.5 4.477.5 10s4.477 10 10 10z\"/>\n    </g>\n    <defs>\n    <clipPath id=\"clip0\">\n        <path d=\"M.5 0h20v20H.5z\"/>\n    </clipPath>\n    </defs>\n  ",
  title: 'Circle',
  viewBox: '0 0 21 20'
};

var circleWithFill = {
  svgPath: "\n    <path d=\"M10.5 14a4 4 0 100-8 4 4 0 000 8z\"/>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.5 10c0 5.523-4.477 10-10 10S.5 15.523.5 10s4.477-10 10-10 10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z\"/>\n  ",
  title: 'Circle With Fill',
  viewBox: '0 0 21 20'
};

var download = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.5.833v10.92l2.876-2.877 1.414 1.414-5.26 5.26-5.706-5.23 1.351-1.474L9.5 11.893V.833h2zm-11.167 15V12.5h2v3.333a2.333 2.333 0 002.333 2.334h11.667a2.333 2.333 0 002.333-2.334V12.5h2v3.333a4.333 4.333 0 01-4.333 4.334H4.666a4.333 4.333 0 01-4.333-4.334z\"/>\n  ",
  title: 'Download',
  viewBox: '0 0 21 21'
};

var arrowLeft = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.414 3.5L4.914 9H19.5v2H4.914l5.5 5.5L9 17.914l-7.207-7.207a1 1 0 010-1.414L9 2.086 10.414 3.5z\"/>\n  ",
  title: 'Arrow Left',
  viewBox: '0 0 21 20'
};

var arrowRight = {
  svgPath: "\n    <path d=\"M18.5 10H2.5M18.5 10L12 16.5M18.5 10L12 3.5\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-linejoin=\"round\"/>\n  ",
  title: 'Arrow Right',
  viewBox: '0 0 21 20'
};

var arrowDown = {
  svgPath: "\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.5 10.086l-5.5 5.5V1H9v14.586l-5.5-5.5L2.086 11.5l7.207 7.207a1 1 0 001.414 0l7.207-7.207-1.414-1.414z\"/>\n  ",
  title: 'Arrow Down',
  viewBox: '0 0 20 20'
};

var arrowDownRight = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.843 2.929l10.314 10.314V5.464h2v10.193a1 1 0 01-1 1H5.964v-2h7.778L3.43 4.343 4.843 2.93z\"/>\n  ",
  title: 'Arrow Down Right',
  viewBox: '0 0 21 20'
};

var arrowUp = {
  svgPath: "\n    <path d=\"M16.5002 9.91421L11.0002 4.41421V19H9.00015L9.00015 4.41421L3.50015 9.91421L2.08594 8.5L9.29304 1.29289C9.68357 0.902369 10.3167 0.902369 10.7073 1.29289L17.9144 8.5L16.5002 9.91421Z\" fill=\"currentColor\"/>\n  ",
  title: 'Arrow Up',
  viewBox: '0 0 20 20'
};

var arrowUpRight = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.611 2.5h10.39a1 1 0 011 1v10.389h-2V5.914l-11 11L3.585 15.5l11-11H6.61v-2z\"/>\n  ",
  title: 'Arrow Up Right',
  viewBox: '0 0 21 20'
};

var avatar = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.444 3.674c-.36.42-.598 1.057-.597 1.863v.002c0 .797.244 1.433.616 1.855.36.409.895.683 1.641.683h.095c.717 0 1.245-.268 1.604-.677.371-.421.616-1.055.616-1.848 0-.795-.25-1.435-.632-1.862-.372-.417-.917-.69-1.649-.69h-.094c-.737 0-1.254.271-1.6.674zM6.927 2.37C7.674 1.502 8.757 1 10.044 1h.095c1.279 0 2.374.5 3.14 1.358.756.847 1.14 1.983 1.14 3.194 0 1.198-.372 2.326-1.114 3.17-.754.856-1.836 1.355-3.106 1.355h-.095c-1.29 0-2.383-.498-3.143-1.361-.747-.849-1.114-1.982-1.114-3.177h1l-1 .001v-.001c0-1.186.349-2.318 1.08-3.169zM4.833 14.454A2.333 2.333 0 002.5 16.788V20h-2v-3.212a4.333 4.333 0 014.333-4.334h11.334a4.333 4.333 0 014.333 4.334V20h-2v-3.212a2.333 2.333 0 00-2.333-2.334H4.833z\"/>\n  ",
  title: 'Avatar',
  viewBox: '0 0 21 20'
};

var calendar = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 1v1h6V1h2v1h4v10.709c0 .897 0 1.632-.049 2.228-.05.618-.158 1.176-.423 1.697a4.334 4.334 0 01-1.894 1.894c-.521.265-1.079.373-1.697.423-.596.049-1.33.049-2.228.049H7.79c-.897 0-1.632 0-2.228-.049-.618-.05-1.176-.158-1.697-.423a4.334 4.334 0 01-1.894-1.894c-.265-.521-.373-1.079-.423-1.697-.049-.596-.049-1.33-.049-2.228V2h4V1h2zm6 3v1h2V4h2v3h-14V4h2v1h2V4h6zm-10 5v3.667c0 .95 0 1.602.042 2.108.04.494.114.759.212.951.224.439.581.796 1.02 1.02.192.098.457.172.951.212.506.041 1.158.042 2.108.042h5.334c.95 0 1.602 0 2.108-.042.494-.04.759-.114.951-.212.439-.224.796-.581 1.02-1.02.098-.192.172-.457.212-.951.041-.506.042-1.158.042-2.108V9h-14z\"/>\n  ",
  title: 'Calendar',
  viewBox: '0 0 21 20'
};

var checkbox = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.5 2h-4c-1.433 0-2.388.002-3.121.061-.71.058-1.035.161-1.241.266a3 3 0 00-1.311 1.311c-.105.206-.208.53-.266 1.24C2.501 5.613 2.5 6.568 2.5 8v4c0 1.433.002 2.388.061 3.121.058.71.161 1.035.266 1.241a3 3 0 001.311 1.311c.206.105.53.208 1.24.266.734.06 1.689.061 3.122.061h4c1.433 0 2.388-.002 3.121-.061.71-.058 1.035-.161 1.241-.266a3 3 0 001.311-1.311c.105-.206.208-.53.266-1.24.06-.734.061-1.689.061-3.122V8c0-1.433-.002-2.388-.061-3.121-.058-.71-.161-1.035-.266-1.241a3 3 0 00-1.311-1.311c-.206-.105-.53-.208-1.24-.266C14.887 2.001 13.932 2 12.5 2zm-11.455.73C.5 3.8.5 5.2.5 8v4c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185C4.3 20 5.7 20 8.5 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185c.545-1.07.545-2.47.545-5.27V8c0-2.8 0-4.2-.545-5.27A5 5 0 0017.77.545C16.7 0 15.3 0 12.5 0h-4C5.7 0 4.3 0 3.23.545A5 5 0 001.045 2.73z\"/>\n  ",
  title: 'Checkbox',
  viewBox: '0 0 21 20'
};

var checkboxFill = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.045 2.73C.5 3.8.5 5.2.5 8v4c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185C4.3 20 5.7 20 8.5 20h4c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185c.545-1.07.545-2.47.545-5.27V8c0-2.8 0-4.2-.545-5.27A5 5 0 0017.77.545C16.7 0 15.3 0 12.5 0h-4C5.7 0 4.3 0 3.23.545A5 5 0 001.045 2.73zm7.748 10.477a1 1 0 001.414 0L15.414 8 14 6.586l-4.5 4.5-2.5-2.5L5.586 10l3.207 3.207z\"/>\n  ",
  title: 'Checkbox Fill',
  viewBox: '0 0 21 20'
};

var facebook = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.936 2.184C.5 3.04.5 4.16.5 6.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 001.748 1.748C3.54 20 4.66 20 6.9 20h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 001.748-1.748c.436-.856.436-1.976.436-4.216V6.4c0-2.24 0-3.36-.436-4.216A4 4 0 0018.316.436C17.46 0 16.34 0 14.1 0H6.9C4.66 0 3.54 0 2.684.436A4 4 0 00.936 2.184zM11.245 17.3v-6.743h2.84l.428-2.514h-3.268V6.87c0-.91.718-1.657 1.616-1.657h1.69V2.7h-1.69c-2.231 0-4.05 1.862-4.05 4.171v1.172h-2.36v2.514h2.36V17.3h2.434z\"/>\n  ",
  title: 'Facebook',
  viewBox: '0 0 21 20'
};

var linkedin = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.936 2.184C.5 3.04.5 4.16.5 6.4v7.2c0 2.24 0 3.36.436 4.216a4 4 0 001.748 1.748C3.54 20 4.66 20 6.9 20h7.2c2.24 0 3.36 0 4.216-.436a4 4 0 001.748-1.748c.436-.856.436-1.976.436-4.216V6.4c0-2.24 0-3.36-.436-4.216A4 4 0 0018.316.436C17.46 0 16.34 0 14.1 0H6.9C4.66 0 3.54 0 2.684.436A4 4 0 00.936 2.184zm3.73 4.483v9.166h2.5V6.667h-2.5zM4.459 4.14c0 .812.654 1.47 1.459 1.47.806 0 1.458-.658 1.458-1.47 0-.812-.653-1.47-1.458-1.47-.805 0-1.458.658-1.458 1.47zm10.209 11.693h2.5v-5.632c0-4.378-4.67-4.219-5.834-2.064v-1.47h-2.5v9.166h2.5v-4.67c0-2.594 3.334-2.806 3.334 0v4.67z\"/>\n  ",
  title: 'LinkedIn',
  viewBox: '0 0 21 20'
};

var instagram = {
  svgPath: "\n    <path d=\"M10.5 7C8.84315 7 7.5 8.34315 7.5 10C7.5 11.6569 8.84315 13 10.5 13C12.1569 13 13.5 11.6569 13.5 10C13.5 8.34315 12.1569 7 10.5 7Z\" fill=\"#111111\"/>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.935974 2.18404C0.5 3.03969 0.5 4.15979 0.5 6.4V13.6C0.5 15.8402 0.5 16.9603 0.935974 17.816C1.31947 18.5686 1.93139 19.1805 2.68404 19.564C3.53969 20 4.65979 20 6.9 20H14.1C16.3402 20 17.4603 20 18.316 19.564C19.0686 19.1805 19.6805 18.5686 20.064 17.816C20.5 16.9603 20.5 15.8402 20.5 13.6V6.4C20.5 4.15979 20.5 3.03969 20.064 2.18404C19.6805 1.43139 19.0686 0.819467 18.316 0.435974C17.4603 0 16.3402 0 14.1 0H6.9C4.65979 0 3.53969 0 2.68404 0.435974C1.93139 0.819467 1.31947 1.43139 0.935974 2.18404ZM16.5417 5.08333C17.117 5.08333 17.5833 4.61696 17.5833 4.04167C17.5833 3.46637 17.117 3 16.5417 3C15.9664 3 15.5 3.46637 15.5 4.04167C15.5 4.61696 15.9664 5.08333 16.5417 5.08333ZM5.5 10C5.5 7.23858 7.73858 5 10.5 5C13.2614 5 15.5 7.23858 15.5 10C15.5 12.7614 13.2614 15 10.5 15C7.73858 15 5.5 12.7614 5.5 10Z\" fill=\"#111111\"/>\n  ",
  title: 'Instagram Icon',
  viewBox: '0 0 21 20'
};

var tiktok = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.48 2.2c-.42-.73-.94-1.36-1.78-1.78C16.86 0 15.71 0 13.51 0H6.39C4.19 0 3.04 0 2.2.42 1.36.84.84 1.36.42 2.2 0 3.04 0 4.19 0 6.39v7.23c0 2.2 0 3.35.42 4.19.42.73.94 1.36 1.78 1.78.84.42 1.99.42 4.19.42h7.23c2.2 0 3.35 0 4.19-.42.73-.42 1.36-.94 1.78-1.78s.42-1.99.42-4.19V6.39c-.1-2.3-.1-3.35-.52-4.19Zm-4.03 6.47c-.1 0-.21.02-.31.02-1.19 0-2.24-.61-2.85-1.54v5.24c0 2.14-1.73 3.87-3.87 3.87s-3.87-1.73-3.87-3.87a3.867 3.867 0 0 1 4.11-3.86v1.91c-.08 0-.16-.02-.24-.02-1.09 0-1.98.88-1.98 1.98s.88 1.98 1.98 1.98 2.06-.86 2.06-1.95l.02-8.9h1.82a3.407 3.407 0 0 0 3.13 3.04v2.12Z\"/>\n  ",
  title: 'Tiktok',
  viewBox: '0 0 21 20'
};

var login = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9545 2.98023e-07L16.2273 0C18.587 -2.38419e-07 20.5 1.91297 20.5 4.27273V15.7273C20.5 18.087 18.587 20 16.2273 20H12.9545V18H16.2273C17.4825 18 18.5 16.9825 18.5 15.7273V4.27273C18.5 3.01754 17.4825 2 16.2273 2L12.9545 2V2.98023e-07ZM9.79802 4.79289L14.975 9.96993L9.82806 15.5848L8.35375 14.2334L11.3177 11L0.5 11V9L11.1767 9L8.3838 6.20711L9.79802 4.79289Z\" fill=\"#111111\"/>\n  ",
  title: 'Login Icon',
  viewBox: '0 0 21 20'
};

var logout = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.5 4.27273C2.5 3.01754 3.51754 2 4.77273 2H8.04545V0H4.77273C2.41297 0 0.5 1.91297 0.5 4.27273V15.7273C0.5 18.087 2.41296 20 4.77273 20H8.04545V18H4.77273C3.51753 18 2.5 16.9825 2.5 15.7273V4.27273ZM13.2628 14.2334L16.2268 11L5.40909 11V9L16.0858 9L13.2929 6.20711L14.7071 4.79289L19.2071 9.29289L19.8841 9.96993L19.2372 10.6757L14.7372 15.5848L13.2628 14.2334Z\" fill=\"#111111\"/>\n  ",
  title: 'Logout Icon',
  viewBox: '0 0 21 20'
};

var chevronUp = {
  svgPath: "\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.375 11.719l1.25 1.562L10 9.78l4.375 3.5 1.25-1.562L10 7.219l-5.625 4.5z\"/>\n  ",
  title: 'Chrevron Up',
  viewBox: '0 0 20 20'
};

var chevronDown = {
  svgPath: "\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.375 8.78l1.25-1.56L10 10.72l4.375-3.5 1.25 1.56L10 13.28l-5.625-4.5z\"/>\n  ",
  title: 'Chrevron Down',
  viewBox: '0 0 20 20'
};

var copy = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.5 2C1.5 1.44772 1.94772 1 2.5 1H13.1667C13.719 1 14.1667 1.44772 14.1667 2V6.33333H18.5C19.0523 6.33333 19.5 6.78105 19.5 7.33333V18C19.5 18.5523 19.0523 19 18.5 19H7.83333C7.28105 19 6.83333 18.5523 6.83333 18V13.6667L2.5 13.6667C2.23478 13.6667 1.98043 13.5613 1.79289 13.3738C1.60536 13.1862 1.5 12.9319 1.5 12.6667V2ZM6.83333 11.6667V7.33333C6.83333 6.78105 7.28105 6.33333 7.83333 6.33333H12.1667V3H3.5V11.6667L6.83333 11.6667ZM8.83333 8.33333V17H17.5V8.33333H8.83333Z\" />\n  ",
  title: 'Copy Icon',
  viewBox: '0 0 21 20'
};

var warningCircle = {
  svgPath: "\n    <circle cx=\"10\" cy=\"10\" r=\"9\" stroke=\"currentColor\" stroke-width=\"2\"/>\n    <path d=\"M10 4L10 12\" stroke=\"currentColor\" stroke-width=\"2\"/>\n    <path d=\"M10 14V16\" stroke=\"currentColor\" stroke-width=\"2\"/>\n  ",
  title: 'Warning Circle',
  viewBox: '0 0 20 20'
};

var chevronRight = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.28049 4.37524L13.7802 9.99994L9.28049 15.6246L7.71875 14.3752L11.219 9.99994L7.71875 5.62463L9.28049 4.37524Z\"/>\n  ",
  title: 'Chrevron Right',
  viewBox: '0 0 21 20'
};

var bell = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 15V9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9V15H21V17H3V15H5ZM17 9C17 6.23858 14.7614 4 12 4C9.23858 4 7 6.23858 7 9V15H17V9Z\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 19C9 20.6569 10.3431 22 12 22C13.6569 22 15 20.6569 15 19H9Z\" /> ",
  title: 'Bell',
  viewBox: '0 0 21 20'
};

var card = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.333 8.333h-2.5V10h2.5V8.333z\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.666 6.666v6.667a3.333 3.333 0 003.333 3.333h10a3.333 3.333 0 003.334-3.333V6.666a3.333 3.333 0 00-3.334-3.333H5a3.333 3.333 0 00-3.333 3.333zM4.999 5h10c.92 0 1.667.746 1.667 1.666v6.667c0 .92-.746 1.667-1.667 1.667H5c-.92 0-1.666-.746-1.666-1.667V6.666c0-.92.746-1.666 1.666-1.666z\" />",
  title: 'Card',
  viewBox: '0 0 21 20'
};

var cardBlocked = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 5H5c-.921 0-1.667.746-1.667 1.666v6.667c0 .92.746 1.667 1.666 1.667h5.834v1.666H4.999a3.333 3.333 0 01-3.333-3.333V6.666a3.333 3.333 0 013.333-3.333h10a3.333 3.333 0 013.334 3.333v1.667h-1.667V6.666c0-.92-.746-1.666-1.667-1.666z\"/>\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.833 8.333h2.5V10h-2.5V8.333zM13.333 12.5h-.834v3.333c0 .92.746 1.667 1.667 1.667h3.333c.92 0 1.667-.747 1.667-1.667V12.5h-.833v-.834a2.5 2.5 0 00-5 0v.834zm1.666 0v-.834a.833.833 0 011.667 0v.834h-1.667zm-.833 1.666h3.333v1.667h-3.333v-1.667z\"/>",
  title: 'Blocked Card',
  viewBox: '0 0 21 20'
};

var smartphone = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.666 14.166H8.333v1.667h3.333v-1.667z\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.166 4.166v11.667a3.333 3.333 0 003.333 3.333h5a3.333 3.333 0 003.334-3.333V4.166A3.333 3.333 0 0012.499.833h-5a3.333 3.333 0 00-3.333 3.333zM7.499 2.5h5c.92 0 1.667.746 1.667 1.666v11.667c0 .92-.746 1.667-1.667 1.667h-5c-.92 0-1.666-.747-1.666-1.667V4.166c0-.92.746-1.666 1.666-1.666z\" />",
  title: 'Smartphone',
  viewBox: '0 0 21 20'
};

var virtualCard = {
  svgPath: "\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.666 13.333V6.666a3.333 3.333 0 013.333-3.333h5.834V5H4.999c-.92 0-1.666.746-1.666 1.666v6.667c0 .92.746 1.667 1.666 1.667h5.834v1.666H4.999a3.333 3.333 0 01-3.333-3.333zM18.228 5.833h-1.785a1.674 1.674 0 00-.61-.61V3.438a3.34 3.34 0 012.395 2.395zM15.833 14.777c.253-.147.464-.358.61-.61h1.785a3.34 3.34 0 01-2.395 2.394v-1.784zM14.166 3.333h-1.667V5h1.667V3.333zM18.333 7.5h-1.667v1.666h1.667V7.5z\" />\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.333 8.333h-2.5V10h2.5V8.333zM16.666 10.833h1.667V12.5h-1.667v-1.667zM12.5 15h1.666v1.666h-1.667V15z\" />",
  title: 'Virtual Card',
  viewBox: '0 0 21 20'
};

var check = {
  svgPath: "\n    <path d=\"M7.15657 12.5566C6.76604 12.9471 6.13288 12.9471 5.74235 12.5566L0.0856746 6.89988L1.49989 5.48567L6.44946 10.4352L16.349 0.535749L17.7632 1.94996L7.15657 12.5566Z\" fill=\"currentColor\" />\n  ",
  title: 'Check'
};

var icons = {
  'check-circle': checkCircle,
  'x-circle': xCircle,
  menu: menu,
  x: x,
  search: search,
  plus: plus,
  minus: minus,
  pencil: pencil,
  circle: circle,
  'circle-with-fill': circleWithFill,
  download: download,
  'arrow-left': arrowLeft,
  'arrow-right': arrowRight,
  'arrow-down': arrowDown,
  'arrow-down-right': arrowDownRight,
  'arrow-up': arrowUp,
  'arrow-up-right': arrowUpRight,
  avatar: avatar,
  calendar: calendar,
  'checkbox-fill': checkboxFill,
  checkbox: checkbox,
  facebook: facebook,
  linkedin: linkedin,
  instagram: instagram,
  twitter: twitter,
  youtube: youtube,
  tiktok: tiktok,
  login: login,
  logout: logout,
  'chevron-up': chevronUp,
  'chevron-down': chevronDown,
  'chevron-right': chevronRight,
  copy: copy,
  'warning-circle': warningCircle,
  bell: bell,
  card: card,
  'card-blocked': cardBlocked,
  smartphone: smartphone,
  'virtual-card': virtualCard,
  check: check
};

/* eslint-disable react/no-danger */
var iconNames = Object.keys(icons);

var Icon = function Icon(_ref) {
  var color = _ref.color,
      colorVariant = _ref.colorVariant,
      name = _ref.name,
      title = _ref.title,
      size = _ref.size,
      className = _ref.className,
      ariaHidden = _ref.ariaHidden;
  var icon = icons[name];
  var iconTitle = title || icon.title;
  return /*#__PURE__*/React__default['default'].createElement(IconStructure, {
    iconName: name,
    title: iconTitle,
    color: color,
    colorVariant: colorVariant,
    "aria-labelledby": iconTitle,
    size: size,
    viewBox: icon.viewBox,
    className: className,
    ariaHidden: ariaHidden
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    dangerouslySetInnerHTML: {
      __html: icon.svgPath
    }
  }));
};

Icon.defaultProps = {
  ariaHidden: undefined,
  color: 'currentColor',
  colorVariant: 'default',
  size: IconStructure.defaultProps.size,
  title: undefined,
  className: ''
};
Icon.propTypes = {
  ariaHidden: index.PropTypes.string,
  className: index.PropTypes.string,
  color: index.PropTypes.string,
  colorVariant: index.PropTypes.string,
  name: index.PropTypes.oneOf(iconNames).isRequired,
  size: IconStructure.propTypes.size,
  title: index.PropTypes.string
};

exports.Icon = Icon;
exports.IconStructure = IconStructure;
//# sourceMappingURL=Icon-b778e008.js.map
